'use strict';

/**
 * Style options for leaflet layers. This file is a duplicate from the default
 * styles declared in draw/lib/LayerStyles, so just reference it here unless we
 * need custom styles in the future.
 */
var Styles = require('../../../../draw/lib/LayerStyles');

module.exports = Styles;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/annotation/lib/LayerStyles.js